const Loading: React.FC = () => {
    return (
        <div className="LoadingBox">
            <span className="loader"></span>
        </div>
    )
}

export default Loading;